import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import styled from "styled-components";
import ListComponent from "../../components/ListComponent";

const data = [
    {
        id: 1,
        title: 'Qatar Diplomatic Mission - Dhaka | Excellence in Modern Diplomatic Architecture | Awarded for Outstanding International Design',
        month: 'January',
        year: 2019,
        published : '12 / 06 / 2020s'
    },
    {
        id: 2,
        title: 'IDCOL Corporate Headquarters - Bangladesh | Sustainable Infrastructure Design Award | Recognized for Green Building Initiatives',
        month: 'January',
        year: 2018,
        published : '12 / 06 / 2020s'
    },
    {
        id: 3,
        title: '7 HOUSE - Innovative Residential Development | Commended for Residential Architecture | Praised for Innovative Urban Living Solutions',
        month: 'January',
        year: 2018,
        published : '12 / 06 / 2020s'
    }
];
const Speeches = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Speeches</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."/>
            </Helmet>
            <StyledComponent>
                <Container>
                    <Row className={'search'}>
                        <Col lg={12}>
                            <ListComponent url={'speeches'} data={data} />
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`
  
`;

export default Speeches;
